<template>
  <footer class="footer">
    <div class="container-fluid">
      <div class="copyright pull-right">
        <p class="copyright text-muted small">Copyright &copy; pretrendr 2017. All Rights Reserved</p>
      </div>
    </div>
  </footer>
</template>
<script>
export default {};
</script>
<style>
footer.footer {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 80px;
}
</style>



// WEBPACK FOOTER //
// src/js/components/engagement/base/ContentFooter.vue